import { MotionConfig } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Global framer-motion config — forces static UI on touch / narrow viewports.
 */
export const MotionProvider = ({ children }) => {
  const staticUI = usePreferStaticUI();

  return (
    <MotionConfig reducedMotion={staticUI ? "always" : "user"}>
      {children}
    </MotionConfig>
  );
};

export default MotionProvider;
